function setupChatwood (baseUrl = 'https://chat.navebild.com.br', websiteToken = 'ZzUqhhssJo2AVyUaqEwjdyeZ') {
  // Cria o script.
  const scriptElement = document.createElement('script')

  // Configura o script.
  scriptElement.src = `${baseUrl}/packs/js/sdk.js`
  scriptElement.async = true
  scriptElement.defer = true

  // Insere o script na página.
  const firstScriptElement = document.getElementsByTagName('script')[0]
  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement)

  // Inicializa o chat.
  scriptElement.onload = () => {
    window.chatwootSDK.run({ baseUrl, websiteToken })
  }
}

function setChatwoodUser (user = {}) {
  if (!user.uuid) return

  window.$chatwoot.setUser(user.uuid, {
    // Identificação.
    name: user.name,
    email: user.email,
    avatar_url: user.photo,

    // Contato.
    city: user.city && `${user.city} - ${user.state}`,
    country_code: 'BR',
    phone_number: user.phone && `+55${user.phone}`,

    // Contexto.
    company_name: user.companyName || 'Almee'
  })
}

// Configura o Chatwoot.
window.chatwootSettings = {
  locale: 'pt-BR',
  position: 'right',
  type: 'expanded_bubble',
  launcherTitle: 'Ajuda'
}

// Boot.
export default () => {
  const status = {
    isLoaded: false,
    isReady: false,
    user: {}
  }

  window.addEventListener('chatwoot:ready', () => {
    status.isReady = true
    setChatwoodUser(status.user)
  })

  const authTypes = ['responseAccessToken', 'updateAccessToken']
  const userTypes = ['responseUser', 'updateUser']

  window.postMessage({ type: 'requestAccessToken' })

  window.addEventListener('message', ({ data }) => {
    // Autenticação.
    if (!status.isLoaded && authTypes.includes(data.type) && data.accessToken) {
      status.isLoaded = true

      setupChatwood()
      window.postMessage({ type: 'requestUser' })
    }

    // Usuário.
    if (userTypes.includes(data.type) && data.user) {
      status.user = data.user

      if (status.isReady) setChatwoodUser(data.user)
    }
  })
}
